import React from "react";
import { ActionField } from "../Components/Columns/ActionField";
import { AmountField } from "../Components/Columns/AmountField";
import { SubscriptionPlanField } from "../Components/Columns/SubscriptionPlanField";
import { TitleField } from "../Components/Columns/TitleField";
import { TypeField } from "../Components/Columns/TypeField";
import { colomnKeys } from "../OfferingVariationsList.constants";
import { KycStatusBadge } from "features/ManageOfferings/modules/PerTierKyc/KycStatusBadge";
import { getKycStatusForRecord } from "features/ManageOfferings/modules/PerTierKyc/PerTierKyc.utils";

export const getTableConfig = () => [
  {
    field: colomnKeys.title.key,
    headerName: colomnKeys.title.label,
    renderColumn: (record) => {
      return <TitleField record={record} />;
    },
  },
  {
    field: "",
    headerName: colomnKeys.price.label,
    emptyField: "N/A",
    sortable: false,
    valueFormatter: (record) => {
      return (
        <AmountField
          domesticPrice={record[colomnKeys.price.domestic_price]}
          internationalPrice={record[colomnKeys.price.international_price]}
        />
      );
    },
  },
  {
    field: "",
    headerName: colomnKeys.subscription_plan.label,
    emptyField: "N/A",
    sortable: false,
    valueFormatter: (record) => {
      return <SubscriptionPlanField record={record} />;
    },
  },
  {
    field: "",
    headerName: colomnKeys.type.label,
    emptyField: "N/A",
    sortable: false,
    valueFormatter: (record) => {
      return <TypeField record={record} />;
    },
    hidden: true,
  },
  {
    field: "",
    headerName: colomnKeys.kyc.label,
    emptyField: "N/A",
    sortable: false,
    valueFormatter: (record) => {
      return <KycStatusBadge mode={getKycStatusForRecord(record)} />;
    },
  },
  {
    field: "",
    headerName: colomnKeys.action.label,
    sortable: false,
    hidden: true,
    fixed: "right",
    valueFormatter: (record) => {
      return <ActionField record={record} />;
    },
  },
];
